import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatBadgeModule} from '@angular/material/badge';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSliderModule} from '@angular/material/slider';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatStepperModule} from '@angular/material/stepper';
import {RoundProgressModule} from 'angular-svg-round-progressbar';

import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTableModule} from '@angular/material/table';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {DragDropModule} from '@angular/cdk/drag-drop';

import {HomeComponent} from './views/home/home.component';
import {FlashBeepComponent} from './views/flash-beep/flash-beep.component';
import {InfoComponent} from './views/info/info.component';
import {PasswordResetComponent} from './views/password-reset/password-reset.component';
import {ScreenResolutionComponent} from './views/screen-resolution/screen-resolution.component';
import {RegistrationFormComponent} from './views/register/participantUser/registrationForm/registrationForm.component';
import {CompleteRegisterComponent} from './views/register/universityUser/completeRegister/completeRegister.component';
import {SuccessRegistrationComponent} from './views/register/participantUser/successRegistration/successRegistration.component';
import {UniRegistrationFormComponent} from './views/register/universityUser/uniRegistrationForm/uniRegistrationForm.component';
import {NavbarComponent} from './views/navbar/navbar.component';
import {LogOnComponent} from './views/logOn/logOn.component';
import {BreakDialog} from './views/dialogs/break/break.dialog';
import {FeedbackDialog} from './views/dialogs/feedback/feedback.dialog';
import {LoadingDialog} from './views/dialogs/loading/loading.dialog';
import {FeedbackCountDialog} from './views/dialogs/feedbackCount/feedbackCount.dialog';
import {InviteRegisterComponent} from './views/invite-register/invite-register.component';
import {MemoryExperimentComponent} from './views/memory-experiment/memory-experiment.component';
import {LoudnessPerceptionComponent} from './views/loudness-perception/loudness-perception.component';
import {TargetDetectionComponent} from './views/target-detection/target-detection.component';
import {ExperimentDataComponent} from './views/experimentData/experimentData.component';
import {ResetPasswordComponent} from './views/password-reset/reset-password/resetPassword/resetPassword.component';

import {StorageService} from './service/storage.service';
import {UserService} from './service/user.service';
import {UniUserService} from './service/uniUser.service';
import {FullScreenService} from './service/fullscreen.service';
import {AuthService} from './service/auth.service';
import {SessionService} from './service/session.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {TbwService} from './service/tbw.service';
import {MemoryService} from './service/memory.service';
import {PersonalitySurveyComponent} from './views/personality-survey/personality-survey.component';
import {QuizService} from './service/quiz.service';
import {TargetDetectionService} from './service/targetDetectionservice';
import {LoudnessPerceptionService} from './service/loudnessPerception.service';
import {TaskService} from './service/tasks.service';
import {QuestionnaireComponent} from './views/questionnaire/questionnaire.component';
import {CategorisationComponent} from './views/memory-experiment/categorisation/categorisation.component';
import {RecognitionComponent} from './views/memory-experiment/recognition/recognition.component';
import {MovementPerceptionComponent} from './views/movement-perception/movement-perception.component';
import {ActualTestComponent} from './views/movement-perception/actual-test/actual-test.component';
import {SketchDemoComponent} from './views/movement-perception/sketch-demo/sketch-demo.component';
import {GetResolutionComponent} from './views/movement-perception/get-resolution/get-resolution.component';
import {PracticeComponent} from './views/movement-perception/practice/practice.component';
import {InstructionsDialog} from './views/dialogs/instructions/instructions.dialog';

import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {ResendLinkComponent} from './views/resend-link/resend-link.component';
import {BlockDialog} from './views/dialogs/block/block.dialog';

import {AdminAreaComponent} from './views/admin-area/admin-area.component';
import {MaintenanceComponent} from './views/maintenance/maintenance.component';

import {NgxCaptchaModule} from 'ngx-captcha';
import {CaptchaComponent} from './views/captcha/captcha-area.component';
import {CaptchaService} from './service/captcha.service';


// Factory function required during AOT compilation
export function httpTranslateLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

// @ts-ignore
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    FlashBeepComponent,
    InfoComponent,
    PasswordResetComponent,
    ScreenResolutionComponent,
    RegistrationFormComponent,
    NavbarComponent,
    CompleteRegisterComponent,
    SuccessRegistrationComponent,
    LogOnComponent,
    InviteRegisterComponent,
    UniRegistrationFormComponent,
    BreakDialog,
    PersonalitySurveyComponent,
    MemoryExperimentComponent,
    LoudnessPerceptionComponent,
    TargetDetectionComponent,
    ExperimentDataComponent,
    ResetPasswordComponent,
    QuestionnaireComponent,
    CategorisationComponent,
    RecognitionComponent,
    FeedbackDialog,
    LoadingDialog,
    FeedbackCountDialog,
    MovementPerceptionComponent,
    ActualTestComponent,
    SketchDemoComponent,
    GetResolutionComponent,
    PracticeComponent,
    InstructionsDialog,
    ResendLinkComponent,
    BlockDialog,
    AdminAreaComponent,
    MaintenanceComponent,
    CaptchaComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    RoundProgressModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoaderFactory,
        deps: [HttpClient]
      }
    }),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatTableModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatBadgeModule,
    DragDropModule,
    NgxCaptchaModule
  ],
  providers: [
    FullScreenService,
    StorageService,
    UserService,
    AuthService,
    UniUserService,
    SessionService,
    DeviceDetectorService,
    TbwService,
    QuizService,
    MemoryService,
    TargetDetectionService,
    LoudnessPerceptionService,
    TaskService,
    CaptchaService
  ],
  entryComponents: [
    BreakDialog
  ],
  bootstrap: [AppComponent],
})

export class AppModule {
}
